/**
 * Node customizado para delays temporais
 * Design com ícone de relógio e informação do tempo
 * Inclui toolbar flutuante ao selecionar
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { Clock } from 'lucide-react';
import { FlowNodeData } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node de delay
 */
export function DelayNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  const duration = nodeData.config?.duration || 0;
  const unit = nodeData.config?.unit || 'seconds';
  
  // Callbacks injetados via FlowCanvas
  const onEdit = (nodeData as any).onEdit;
  const onDuplicate = (nodeData as any).onDuplicate;
  const onDelete = (nodeData as any).onDelete;
  const onTestFromHere = (nodeData as any).onTestFromHere;
  
  // Formata a duração para exibição
  const formatDuration = () => {
    const unitLabels: Record<string, string> = {
      seconds: 'segundos',
      minutes: 'minutos',
      hours: 'horas',
      days: 'dias'
    };
    return `${duration} ${unitLabels[unit] || unit}`;
  };

  return (
    <div className="bg-card rounded-lg shadow-lg border-2 border-amber-500 min-w-[180px]">
      {/* Toolbar flutuante */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType={nodeData.type}
        onEdit={onEdit}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTestFromHere={onTestFromHere}
        isVisible={selected}
      />
      
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-amber-500 !w-3 !h-3"
      />
      
      <div className="p-3">
        <div className="flex items-center gap-2 mb-2">
          <div className="bg-amber-500/10 text-amber-600 p-2 rounded">
            <Clock className="h-4 w-4" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm text-foreground">
              {nodeData.config?.nickname || 'Aguardar'}
            </div>
          </div>
        </div>
        
        <div className="text-xs text-muted-foreground bg-muted/50 rounded p-2 text-center font-medium">
          {formatDuration()}
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-amber-500 !w-3 !h-3"
      />
    </div>
  );
}
